import { Mic, Video, Clapperboard } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import usePageContent from "@/hooks/usePageContent";
import ScrollReveal from "@/components/ScrollReveal";
import StaggerContainer from "@/components/StaggerContainer";

const ServicesSection = () => {
  const { t } = useTranslation();
  const { getContent } = usePageContent("home");

  const services = [
    {
      icon: Mic,
      title: getContent("services_item1_title", t("servicesSection.voiceoverCasting")),
      description: getContent("services_item1_desc", t("servicesSection.voiceoverCastingDesc")),
    },
    {
      icon: Video,
      title: getContent("services_item2_title", t("servicesSection.onCameraTalent")),
      description: getContent("services_item2_desc", t("servicesSection.onCameraTalentDesc")),
    },
    {
      icon: Clapperboard,
      title: getContent("services_item3_title", t("servicesSection.productionSupport")),
      description: getContent("services_item3_desc", t("servicesSection.productionSupportDesc")),
    },
  ];

  return (
    <section id="services" className="section-padding bg-background">
      <div className="container-wide">
        {/* Section Header */}
        <ScrollReveal className="text-center mb-10 sm:mb-16">
          <h2 className="heading-section mb-3 sm:mb-4 text-primary">
            {getContent("services_title", t("servicesSection.title"))}
          </h2>
          <p className="text-editorial max-w-xl mx-auto text-[0.9375rem] sm:text-base">
            {getContent("services_subtitle", t("servicesSection.subtitle"))}
          </p>
        </ScrollReveal>

        {/* Services Grid */}
        <StaggerContainer className="grid grid-cols-1 gap-6 sm:grid-cols-3 sm:gap-6 md:gap-8 items-stretch" staggerDelay={0.12}>
          {services.map((service, index) => (
            <div 
              key={index} 
              className="group p-6 sm:p-8 border border-border hover:border-foreground transition-all duration-300 bg-card h-full flex flex-col"
            >
              <div className="mb-4 sm:mb-6">
                <service.icon size={28} strokeWidth={1.5} className="text-primary" />
              </div>
              <h3 className="heading-card mb-3 sm:mb-4 text-primary">{service.title}</h3>
              <p className="text-editorial flex-1 text-[0.9375rem] sm:text-base">{service.description}</p>
            </div>
          ))}
        </StaggerContainer>

        {/* CTA Button */}
        <ScrollReveal className="text-center mt-10 sm:mt-14">
          <Button asChild variant="sectionCta">
            <Link to="/services">{t("servicesSection.cta", "Our Services")}</Link>
          </Button>
        </ScrollReveal>
      </div>
    </section>
  );
};

export default ServicesSection;
